import { forwardRef } from 'react';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

type Props = {
  handleClose: () => void;
  showMessage: string;
  isSuccess: boolean;
};
const Notification = ({ handleClose, showMessage, isSuccess }: Props) => {
  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
  });

  return (
    <Snackbar
      open={!!showMessage}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      data-testid='snackbar'
    >
      <Alert
        onClose={handleClose}
        severity={isSuccess ? 'success' : 'error'}
        sx={{ width: '100%' }}
      >
        {showMessage}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
